import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core';
import { formatNumber } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'myCurrency'
})

export class UserCurrencyPipe implements PipeTransform {
  userInfo: any = (window as any).userInfo;

  constructor(@Inject(LOCALE_ID) private locale: string, private sanitizer: DomSanitizer) { }
  transform(value: number): SafeHtml {
    // return this.userInfo.currency_symbol + ' ' + formatNumber(value, this.locale, '.2');
    const currencySymbol = this.userInfo.currency_symbol; // Can be text or <img> tag
    const formattedValue = formatNumber(value, this.locale, '.2');

    // Construct safe HTML
    const safeHtml = `${currencySymbol} ${formattedValue}`;

    // Bypass Angular's sanitization to allow the image tag
    return this.sanitizer.bypassSecurityTrustHtml(safeHtml);
  }

}
